import React from "react";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle } from "@ionic/react";

interface Props {
  title: string;
  /** Route de repli si aucun historique (bouton retour Ionic) */
  backTo?: string;
  color?: string;
  right?: React.ReactNode;
}

/** En-tête standard avec bouton retour (Ionic gère la safe area iOS). */
const PageHeader: React.FC<Props> = ({ title, backTo, color, right }) => (
  <IonHeader className="ion-no-border">
    <IonToolbar>
      {backTo && (
        <IonButtons slot="start">
          <IonBackButton defaultHref={backTo} text="" />
        </IonButtons>
      )}
      <IonTitle>
        <span className="flex items-center gap-2 font-bold">
          {color && <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ background: color }} />}
          <span className="truncate">{title}</span>
        </span>
      </IonTitle>
      {right && <IonButtons slot="end">{right}</IonButtons>}
    </IonToolbar>
  </IonHeader>
);

export default PageHeader;
